if(!customElements.get('blog-search')) {
  customElements.define(
    'blog-search',
    class BlogSearch extends HTMLElement {
      form = undefined;

      constructor() {
        super()
      }

      connectedCallback() {
        this.form = this.querySelector('form');
        init();
      }
      
      init() {
        if(!this.form) return;

        this.form.addEventListener('submit', this.handleSearch);
      }

      performSearch(e) {
        e.preventDefault();
        
        const formData = new FormData(e.currentTarget);
        const query = formData.get("q");
        if(!query?.trim()) return;

        const encodedQuery = encodedQuery = encodeURIComponent(query.trim());
        window.location.href = `/search?q=${encodedQuery}&type=article`;
      }
    }
  );
}